import { srsApiUrl } from '../utils/apiUrls';
import store from '../store/store';
import exportFile from './exportFile';
import i18n from '../i18n/config';

const readStoredUser = () => {
    try {
        return JSON.parse(localStorage.getItem('mvc-user')) || {};
    } catch {
        return {};
    }
};

/**
 * Resolves the auth headers at call time from the store, falling back to the
 * persisted `mvc-user` the same way the wretch client does. Reading lazily
 * (instead of via a module-level `store.subscribe`) means a tab that has not
 * emitted a store update since this module loaded still sends a real token
 * rather than the string "null".
 */
export const getAuthHeaders = () => {
    const { id, token, selectedClientId } = store.getState()?.user ?? {};
    const stored = token && id && selectedClientId ? {} : readStoredUser();

    return {
        'x-auth-token': token || stored.token,
        'x-auth-user-id': id || stored.id,
        'x-client-id': selectedClientId || stored.selectedClientId,
    };
};

const createPDF = async ({ reqBody, type, document, filename, notif }) => {
    const url = `${srsApiUrl}/${type}`;

    // Add locale to request body if not already present
    const bodyWithLocale = {
        ...reqBody,
        locale: reqBody.locale || i18n.language || 'en-US',
    };

    const fetchPDFres = await fetch(url, {
        method: 'post',
        body: JSON.stringify(bodyWithLocale),
        headers: {
            'content-type': 'application/json',
            'api-consumer-key': 'mvc',
            ...getAuthHeaders(),
        },
    });

    if (fetchPDFres.status !== 200) {
        const body = await fetchPDFres.text();
        const error = new Error(
            body ||
                fetchPDFres.message ||
                fetchPDFres.statusText ||
                fetchPDFres.status,
        );
        error.response = fetchPDFres;
        error.status = fetchPDFres.status;
        throw error;
    }

    const fetchPDFJson = await fetchPDFres.json();
    const pdfUrl = fetchPDFJson.pdfUrl;

    await exportFile({ url: pdfUrl, document, filename, notif, type: 'pdf' });
    return fetchPDFJson;
};

export default createPDF;
